import Reveal from '@/components/feature/Reveal';
import { rankingList } from '@/mocks/home';

export default function HotRanking() {
  return (
    <section id="ranking" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-8 md:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-primary-600 uppercase">
              <i className="ri-trophy-line" /> 热评榜
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
              今晚大家都在跟哪条热评
            </h2>

            <div className="mt-8 md:mt-10 flex flex-col divide-y divide-background-200 border-y border-background-200">
              {rankingList.map((item, index) => (
                <Reveal key={item.rank} delay={index * 40}>
                  <a href="#campus" className="group grid grid-cols-[44px_1fr] md:grid-cols-[56px_1fr_auto] items-center gap-4 md:gap-6 py-4 md:py-5 cursor-pointer">
                    <span
                      className={`w-11 h-11 md:w-14 md:h-14 rounded-md flex items-center justify-center font-heading text-xl md:text-2xl font-black ${
                        item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500 border border-background-200'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0">
                      <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                        {item.title}
                      </h3>
                      <div className="mt-2 flex items-center gap-4 flex-wrap text-xs text-foreground-500">
                        <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                          <i className="ri-user-3-line" /> {item.author}
                        </span>
                        <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                          <i className="ri-fire-line text-primary-500" /> {item.heat}
                        </span>
                      </div>
                      <div className="mt-3 h-1.5 rounded-full bg-background-200 overflow-hidden">
                        <div
                          className={`h-full rounded-full ${item.rank <= 3 ? 'bg-primary-500' : 'bg-secondary-400'}`}
                          style={{ width: `${item.percent}%` }}
                        />
                      </div>
                    </div>
                    <i className="hidden md:flex ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 w-8 h-8 items-center justify-center" />
                  </a>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={100}>
            <div className="lg:sticky lg:top-24 flex flex-col gap-5">
              <div className="rounded-lg overflow-hidden border border-background-200 bg-background-100">
                <div className="relative w-full h-48">
                  <img
                    src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20warm%20crimson%20and%20amber%20paper%20layers%20with%20concentric%20rings%20and%20grain%20texture%2C%20dramatic%20studio%20lighting%2C%20bold%20graphic%20poster%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20rich%20warm%20tones&width=800&height=560&seq=hlws-rank-01&orientation=landscape"
                    alt="黑料网社热评榜精选封面"
                    title="黑料网社 热评榜 精选封面"
                    className="w-full h-full object-top"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <p className="text-xs font-bold tracking-[0.2em] text-accent-700 uppercase">榜单说明</p>
                  <h3 className="mt-3 font-heading text-xl font-bold text-foreground-950">热评由公共区实时投票产生</h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                    每 10 分钟刷新一次，老哥的跟评、粉丝团的整理帖都会计入权重，越聊越靠前。
                  </p>
                  <div className="mt-5 grid grid-cols-2 gap-3">
                    <div className="rounded-md bg-background-50 border border-background-200 px-4 py-3">
                      <p className="font-heading text-xl font-black text-primary-600">10min</p>
                      <p className="mt-1 text-xs text-foreground-500">刷新频率</p>
                    </div>
                    <div className="rounded-md bg-background-50 border border-background-200 px-4 py-3">
                      <p className="font-heading text-xl font-black text-secondary-700">46</p>
                      <p className="mt-1 text-xs text-foreground-500">参与讨论群</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}